module.exports = __webpack_public_path__ + "img/idcard-front.e8706df5.png";